import styled from '@emotion/styled';
import { spacing } from '@naf/theme';
import { colors } from '@naf-simba/theme';

export const MembershipActiveContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing.space16};
  padding: ${spacing.space24};
  background: ${colors.secondary[50]};
  border-radius: ${spacing.space8};

  p,
  h6 {
    margin: 0;
  }
`;
